<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="addNewUser addNewSession f-s-s f-d-c w-100 h-90 p-4">
      <div class="return w-100 f-c-e mb-4">
        <div class="f-c-s returnBtn" @click="returnFunc()">
          <!-- <div class="arrow f-c-c ml-1">&lt;</div> -->
          <div class="returnText f-c-c">برگشت</div>
        </div>
      </div>
      <div class="progressSection f-c-b w-100 mb-4">
        <div class="item active f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">1</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
        <div class="item f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">2</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
        <div class="item f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">3</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
      </div>
      <div class="title f-c-s w-100 pt-3 mb-4">
        <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/folder.svg`)"></b-img>
        <div class="title-text f-c-c">افزودن جلسه جدید</div>
      </div>
      <div
        class="addUserBox f-c-s f-d-c w-100 h-100"
        style="border-top: 1px solid #125488; border-radius: 10px"
      >
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">عنوان</div>
          <input v-model="title" @keyup="enterTitle" :maxlength="max" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">ظرفیت <span class="mr-1 fs12"> (نفر) </span></div>
          <input v-model="capacity" type="number" placeholder="100" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">گروه جلسه</div>
          <div class="left f-c-b">
            <select class="sessionGroup" v-model="sessionGroup">
              <option v-for="(v, i) in allSessionGroupsList" :key="i" :value="v.id">
                {{ v.title }}
              </option>
            </select>
            <div @click.prevent="addGroupFunc()" class="addGroup f-c-c">
              <span class="plus ml-2">+</span>
              <div class="text f-c-c">افزودن گروه</div>
            </div>
          </div>
        </div>
        <div v-if="user.is_organ == 'yes'" class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">سازمان</div>
          <div class="left f-c-b">
            <select class="sessionGroup w-100" v-model="userOrg">
              <option v-for="(v, i) in allUserOrgList" :key="i" :value="v.id">
                {{ v.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="tabSection f-c-b p-1">
            <div
              @click="isTabAvtive = 1"
              class="single f-c-c"
              :class="[isTabAvtive == 1 ? 'activeTab' : '']"
            >
              تک جلسه ای
            </div>
            <div
              @click="isTabAvtive = 2"
              class="single f-c-c"
              :class="[isTabAvtive == 2 ? 'activeTab' : '']"
            >
              چند جلسه ای
            </div>
          </div>
        </div>
        <div class="row f-c-c w-100 mb-4">
          <div class="tabContent f-c-s f-d-c p-3 mb-3">
            <div class="w-100 mb-3" :class="[isTabAvtive == 1 ? 'f-c-b single' : 'multi f-c-b']">
              <div class="right f-c-b" :class="[isTabAvtive == 1 ? 'w-48' : '']">
                <div class="label f-c-s">
                  {{ isTabAvtive == 1 ? "تاریخ" : "تاریخ شروع" }}
                </div>
                <div class="date f-c-s">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/calendar-icon.svg`)"
                  ></b-img>
                  <pdatepicker
                    v-model="startDate"
                    header-background-color="#125488"
                    hover-day-back-color="#8ebbdf"
                    chosen-day-back-color="#8ebbdf"
                    @selected="selectStartDate"
                    :placeholder="startDate ? startDate : ''"
                  ></pdatepicker>
                </div>
              </div>
              <div v-if="isTabAvtive == 2" class="left f-c-b">
                <div class="label f-c-c">تاریخ پایان</div>
                <div class="date f-c-s">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/calendar-icon.svg`)"
                  ></b-img>
                  <pdatepicker
                    :key="componentKey"
                    dialog
                    class="endDateId"
                    v-model="endDate"
                    header-background-color="#125488"
                    hover-day-back-color="#8ebbdf"
                    chosen-day-back-color="#8ebbdf"
                    :availableDates="dateTrue"
                    :availableDateStart="startDateLimit"
                    :placeholder="endDate ? endDate : ''"
                  ></pdatepicker>
                </div>
              </div>
            </div>
            <div class="timeSection f-c-b w-100 mb-3">
              <div class="right f-c-b">
                <div class="label f-c-c">ساعت شروع</div>
                <div class="time f-c-c">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/clock-icon.svg`)"
                  ></b-img>
                  <vue-timepicker
                    v-model="startTime"
                    drop-direction="up"
                    hour-label="ساعت"
                    minute-label="دقیقه"
                    placeholder="00:00"
                  ></vue-timepicker>
                </div>
              </div>
              <div class="left f-c-b">
                <div class="label f-c-c">ساعت پایان</div>
                <div class="time f-c-c">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/clock-icon.svg`)"
                  ></b-img>
                  <vue-timepicker
                    v-model="endTime"
                    drop-direction="up"
                    hour-label="ساعت"
                    minute-label="دقیقه"
                    placeholder="00:00"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
            <!-- <div v-if="isTabAvtive == 2" class="row f-s-c w-100 mb-2 mt-3">
              <div class="multi-table w-100">
                <div class="table-header w-100">
                  <div
                    class="header-item"
                    v-for="(v, i) in days"
                    :key="i"
                    style="color: #212529"
                  >
                    {{ v.title }}
                  </div>
                </div>
                <div class="table-content w-100 h-100">
                  <div
                    class="body-item"
                    v-for="(v, i) in days"
                    :key="i"
                    style="color: #212529"
                  >
                    <div
                      v-for="(d, j) in selectDaysList[i]"
                      :key="j"
                      class="sansItem f-d-c"
                      @mouseover="ishover = i + '-' + j"
                      @mouseleave="ishover = null"
                      :class="[ishover == i + '-' + j ? 'f-c-c' : 'f-c-sa']"
                    >
                      <div class="text f-c-c w-100">
                        {{ d.start + " الی " + d.end }}
                      </div>
                      <div v-if="ishover == i + '-' + j" class="f-c-c w-100">
                        <b-img
                          @click.prevent="editSansFunc(d, j, i)"
                          class="ml-2"
                          :src="require(`@/assets/images/gap/edit-icon.svg`)"
                        ></b-img>
                        <b-img
                          @click.prevent="deleteSansFunc(d, j, i)"
                          :src="require(`@/assets/images/gap/delete-icon.svg`)"
                        ></b-img>
                      </div>
                    </div>
                    <div @click="addNewSansFunc(i)" class="add-sans f-c-c">
                      +
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div v-if="isTabAvtive == 2" class="selectDay f-c-b w-100 mb-4">
              <div class="label f-c-s">انتخاب روز</div>
              <div class="dayBox f-c-b f-w-w">
                <div
                  v-for="(v, i) in days"
                  :key="i"
                  class="day f-c-c"
                  @click="selectDayFunc(v)"
                  :class="[isactive.includes(v.value) ? 'active' : '']"
                >
                  {{ v.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="saveStepOneBtn row f-c-c w-100">
          <div class="btnSec f-c-c">
            <div class="save f-c-c" @click.prevent="saveStepOneFunc()">ادامه</div>
          </div>
        </div>
      </div>
    </div>
    <div class="gapMaterial f-c-c w-100">
      <div class="text blueText f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می باشد.
      </div>
    </div>
    <b-modal
      id="repeatPeriod-modal"
      title="ثبت دوره تکرار"
      button-size="sm"
      :hide-footer="footer"
      size="lg"
      ref="repeatPeriod-modal"
      @hidden="repeatPeriodHideModal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="repeatPeriodSection f-c-c w-100">
          <div class="repeatPeriodBox f-c-c f-d-c w-100">
            <div class="selectDate f-c-s w-100 mb-4">
              <div class="label f-c-s">انتخاب تاریخ</div>
              <div class="date f-c-s">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/calendar-icon-blue.svg`)"
                ></b-img>
                <pdatepicker
                  v-model="startDate"
                  header-background-color="#439889"
                  hover-day-back-color="#439889"
                  chosen-day-back-color="#439889"
                  :placeholder="startDate ? startDate : '1401/1/1'"
                  wrapper-class="calander1 f-c-c"
                ></pdatepicker>
              </div>
              <div class="until f-c-c">تا</div>
              <div class="date f-c-s">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/calendar-icon-blue.svg`)"
                ></b-img>
                <pdatepicker
                  v-model="endDate"
                  dialog
                  class="endDateId"
                  header-background-color="#439889"
                  hover-day-back-color="#439889"
                  chosen-day-back-color="#439889"
                  :placeholder="endDate ? endDate : '1401/1/1'"
                  wrapper-class="calander2 f-c-c"
                ></pdatepicker>
              </div>
            </div>
            <div class="selectDay f-s-s w-100 mb-4">
              <div class="label f-c-s">انتخاب روز</div>
              <div class="dayBox f-c-c f-w-w">
                <div
                  v-for="(v, i) in days"
                  :key="i"
                  class="day f-c-c"
                  @click="selectDayFunc(v)"
                  :class="[isactive.includes(v.value) ? 'active' : '']"
                >
                  {{ v.title }}
                </div>
              </div>
            </div>
            <div class="selectDate f-c-s w-100 mb-5">
              <div class="label f-c-s">انتخاب ساعت</div>
              <div class="time f-c-c">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/clock-icon-blue.svg`)"
                ></b-img>
                <vue-timepicker
                  v-model="startTime"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="15:00"
                ></vue-timepicker>
              </div>
              <div class="until f-c-c">تا</div>
              <div class="time f-c-c">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/clock-icon-blue.svg`)"
                ></b-img>
                <vue-timepicker
                  v-model="endTime"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="15:00"
                ></vue-timepicker>
              </div>
            </div>
            <div class="saveRepeatPeriodBtnSection f-c-c w-100">
              <div class="saveRepeatPeriodBtn f-c-c" @click.prevent="saveRepeatPeriodFunc()">
                ذخیره
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="edit-modal"
      title="افزودن گروه جدید"
      button-size="sm"
      :hide-footer="footer"
      ref="addGroup-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-5 mt-3">
          <div class="label f-c-s">عنوان</div>
          <input v-model="addGroup.name" type="text" />
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveGroupFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="edit-modal"
      :title="isSansEdit ? 'ویرایش' : 'افزودن سانس جدید'"
      button-size="sm"
      :hide-footer="footer"
      ref="addSans-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-s w-100 m-0 mb-4 mt-3">
          <div class="label f-c-s w-fit ml-2">روز</div>
          <div class="left f-c-b w-50">
            <select class="sessionGroup w-100" v-model="selectedDay" :disabled="isSansEdit">
              <option v-for="(v, i) in days" :key="i" :value="v.id">
                {{ v.fullTitle }}
              </option>
            </select>
          </div>
        </div>
        <div class="row f-c-s w-100 m-0 mb-4">
          <div class="timeSection f-c-b w-100 mb-3">
            <div class="right f-c-b">
              <div class="label f-c-c">ساعت شروع</div>
              <div class="time f-c-c">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/clock-icon.svg`)"
                ></b-img>
                <vue-timepicker
                  v-model="multistartTime"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="00:00"
                ></vue-timepicker>
              </div>
            </div>
            <div class="left f-c-b">
              <div class="label f-c-c">ساعت پایان</div>
              <div class="time f-c-c">
                <b-img
                  class="title-icon ml-2"
                  :src="require(`@/assets/images/gap/clock-icon.svg`)"
                ></b-img>
                <vue-timepicker
                  v-model="multiendTime"
                  format="HH:mm"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="00:00"
                ></vue-timepicker>
              </div>
            </div>
          </div>
        </div>

        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveSansFunc()">
            {{ isSansEdit ? "ویرایش" : "ذخیره" }}
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="delete-modal"
      title="توجه"
      button-size="sm"
      :hide-footer="footer"
      ref="attention-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="text f_c_c w-100 mb-5 mt-4">
          لطفاً در انتخاب تعداد روز و ساعت دقت نمایید.
          <br />
          <br />
          هزینه، براساس
          <b> نفر ساعت </b>
          محاسبه می گردد.
        </div>
        <div class="btnSection w-100 f-c-c">
          <div class="btnItem1 f_c_c ml-2" @click="hideModal()">
            {{ "بستن" }}
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "AddNewSission1",
  data() {
    return {
      max: 30,
      startDate: "",
      isBigger: false,
      startDateLimit: "",
      componentKey: 0,
      selectedDay: 0,
      selectedDaySansId: 0,
      isTabAvtive: 1,
      title: "",
      capacity: "",
      userOrg: "",
      sessionGroup: "",
      iswatie: false,
      isSave: false,
      isSansEdit: false,
      ishover: null,
      startTime: "00:00",
      endTime: "00:00",
      multistartTime: "00:00",
      multiendTime: "00:00",
      endDate: "",
      repeatPeriod: "2",
      footer: true,
      dateTrue: true,
      isactive: [],
      allUserOrgList: [],
      allSessionGroupsList: [],
      minuteRange: [],
      hourRange: [],
      addGroup: {
        name: "",
      },
      days: [
        { id: 0, title: "ش", fullTitle: "شنبه", value: "saturday" },
        { id: 1, title: "ی", fullTitle: "یکشنبه", value: "sunday" },
        { id: 2, title: "د", fullTitle: "دوشنبه", value: "monday" },
        { id: 3, title: "س", fullTitle: "سه شنبه", value: "tuesday" },
        { id: 4, title: "چ", fullTitle: "چهارشنبه", value: "wednesday" },
        { id: 5, title: "پ", fullTitle: "پنجشنبه", value: "thursday" },
        { id: 6, title: "ج", fullTitle: "جمعه", value: "friday" },
      ],
      selectDaysList: [[], [], [], [], [], [], []],
    };
  },
  created() {
    this.startDateLimit = this.sessionStep1Data.startDateLimit;
    this.getAllUserOrgFunction({
      user_id: this.user.user_id,
    });
    this.getAllSessionGroupsFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allSessionGroups: (state) => state.gap.allSessionGroups,
      setSessionGroupStatus: (state) => state.gap.setSessionGroupStatus,
      sessionStep1Data: (state) => state.gap.sessionStep1Data,
      allUserOrg: (state) => state.gap.allUserOrg,
    }),
  },
  methods: {
    ...mapActions("gap", [
      "getAllSessionGroupsFunction",
      "setSessionGroupFunction",
      "setSessionStep1DataFunction",
      "setSessionStep2DataFunction",
      "setSessionStep3DataFunction",
      "setAppTitleFunction",
      "getAllUserOrgFunction",
    ]),
    enterTitle(n) {
      let toast = document.querySelector("#b-toaster-top-right .b-toast");
      if (n.target.value.length == 30) {
        if (!toast) {
          this.$bvToast.toast("عنوان جلسه نباید بیشتر از 30 کارکتر باشد.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    editSansFunc(d, j, i) {
      this.isSansEdit = true;
      this.selectedDay = i;
      this.selectedDaySansId = j;
      this.multistartTime = d.start;
      this.multiendTime = d.end;
      this.$refs["addSans-modal"].show();
    },
    deleteSansFunc(d, j, i) {
      this.ishover = null;
      this.selectDaysList[i].splice(j, 1);
    },
    saveSansFunc() {
      this.ishover = null;
      if (this.isSansEdit) {
        this.selectDaysList[this.selectedDay][this.selectedDaySansId].start = this.multistartTime;
        this.selectDaysList[this.selectedDay][this.selectedDaySansId].end = this.multiendTime;
        this.isSansEdit = false;
      } else {
        this.selectDaysList[this.selectedDay].push({
          start: this.multistartTime,
          end: this.multiendTime,
        });
      }
      this.$refs["addSans-modal"].hide();
    },
    addNewSansFunc(i) {
      this.isSansEdit = false;
      this.selectedDay = i;
      this.multistartTime = "00:00";
      this.multiendTime = "00:00";
      this.$refs["addSans-modal"].show();
    },
    RepeatPreviousDayFunc() {},
    openAttentionModal() {
      this.$refs["attention-modal"].show();
    },
    hideModal() {
      this.$refs["attention-modal"].hide();
    },
    selectDateFunc() {},
    repeatPeriodHideModal() {
      if (!this.isSave) {
        this.isactive = [];
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    sliceTime(t) {
      let Hfilter = [];
      let Mfilter = [];
      let time = t.split(":");
      let Hindex = parseInt(time[0]);
      let Mindex = parseInt(time[1]);
      for (Mindex; Mindex < 60; Mindex++) {
        Mfilter.push(Mindex);
      }
      for (Hindex; Hindex < 24; Hindex++) {
        Hfilter.push(Hindex);
      }
      this.hourRange = Hfilter;
      this.minuteRange = Mfilter;
    },
    repeatPeriodCheck() {
      setTimeout(() => {
        if (this.repeatPeriod == 1) {
          this.$refs["repeatPeriod-modal"].show();
        }
      }, 1500);
    },
    selectStartDate(e) {
      this.startDate = e.year + "/" + e.month + "/" + e.day;
      this.startDateLimit = e.year + "/" + e.month + "/" + e.day;
      setTimeout(() => {
        this.forceRerender();
      }, 200);
    },
    selectDayFunc(v) {
      if (this.isactive.includes(v.value)) {
        let id = this.isactive.indexOf(v.value);
        this.isactive.splice(id, 1);
      } else {
        this.isactive.push(v.value);
      }
    },
    showModal() {
      if (this.repeatPeriod == 1) {
        this.repeatPeriod = 2;
        this.$refs["repeatPeriod-modal"].hide();
        this.isactive = [];
      } else {
        this.repeatPeriod = 1;
        this.$refs["repeatPeriod-modal"].show();
      }
    },
    saveRepeatPeriodFunc() {
      this.isSave = true;
      this.$refs["repeatPeriod-modal"].hide();
    },
    saveStepOneFunc() {
      const targetDate = new Date(1403, 7, 29);
      const userDate = new Date(this.startDate);

      if (this.title == "" || this.title.length <= 2) {
        this.$bvToast.toast("وارد کردن عنوان اجباری است(حداقل 3 کارکتر)", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.userOrg == "" && this.user.is_organ == "yes") {
        this.$bvToast.toast("سازمان را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.capacity == "") {
        this.$bvToast.toast("ظرفیت را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.startDate == "") {
        this.$bvToast.toast("تاریخ شروع را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.startTime == "") {
        this.$bvToast.toast("زمان شروع را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.endDate == "") {
        this.$bvToast.toast("تاریخ پایان را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.endTime == "") {
        this.$bvToast.toast("زمان پایان را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.repeatPeriod == "1" && this.isactive.length == 0) {
        this.$bvToast.toast("در دوره تکرار روزی را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (userDate >= targetDate) {
        this.$bvToast.toast(
          "امکان ساخت جلسه در این نسخه از تاریخ 29 آبان 1403 به بعد وجود ندارد!",
          {
            title: "خطا",
            variant: "danger",
            solid: true,
          }
        );
      } else {
        this.setSessionStep1DataFunction({
          title: this.title,
          capacity: this.capacity,
          userOrg: this.userOrg,
          sessionGroup: this.sessionGroup,
          startDate: this.startDate,
          startTime: this.startTime,
          endDate: this.endDate,
          endTime: this.endTime,
          days: this.isactive,
          isRepeat: this.repeatPeriod,
          isTabAvtive: this.isTabAvtive,
          daysList: this.selectDaysList,
        });
        this.$router.push({ name: "addNewSission2" });
      }
    },
    returnFunc() {
      this.setAppTitleFunction("جلسات من");
      this.$router.push({ name: "myMeets" });
      this.setSessionStep1DataFunction({});
      this.setSessionStep2DataFunction({});
      this.setSessionStep3DataFunction({});
    },
    addGroupFunc() {
      this.addGroup.name = "";
      this.$refs["addGroup-modal"].show();
    },
    saveGroupFunc() {
      this.setSessionGroupFunction({
        user_id: this.user.user_id,
        title: this.addGroup.name,
      });
      this.$refs["addGroup-modal"].hide();
    },
  },
  watch: {
    startTime() {
      // this.sliceTime(n);
    },
    allUserOrg(n) {
      if (Object.keys(n).length) {
        this.allUserOrgList = n.organ_list;
      }
    },
    allSessionGroups(n) {
      if (Object.keys(n).length) {
        this.allSessionGroupsList = n.session_groups;
      }
    },
    endTime() {
      // setTimeout(() => {
      //   let startTime = this.startTime.split(":");
      //   let endTime = n.split(":");
      //   let startDate = this.startDate.split("/");
      //   let endDate = this.startDate.split("/");
      //   if (
      //     parseInt(startDate[1]) == parseInt(endDate[1]) &&
      //     parseInt(startDate[2]) == parseInt(endDate[2])
      //   ) {
      //     if (parseInt(endTime[0]) < parseInt(startTime[0])) {
      //       this.$bvToast.toast(
      //         "زمان پایان نمی تواند کمتر از زمان شروع باشد.",
      //         {
      //           title: "خطا",
      //           variant: "danger",
      //           solid: true,
      //         }
      //       );
      //       let el = document.getElementById("sessionStep1EndTime");
      //       el.classList.add("errorTime");
      //     } else {
      //       document
      //         .getElementById("sessionStep1StartTime")
      //         .classList.remove("errorTime");
      //     }
      //   }
      // }, 2000);
    },
    startDate(n) {
      if (this.isTabAvtive == 1) {
        this.endDate = n;
        let sDay = n.split("/")[2];
        let eDay = this.endDate.split("/")[2];
        if (parseInt(sDay) >= parseInt(eDay)) {
          this.isBigger = false;
        } else {
          this.isBigger = true;
        }
      } else {
        if (!this.endDate) {
          this.endDate = n;
          let sDay = n.split("/")[2];
          let eDay = this.endDate.split("/")[2];
          if (parseInt(sDay) >= parseInt(eDay)) {
            this.isBigger = false;
          } else {
            this.isBigger = true;
          }
        }
      }
    },
    endDate(n) {
      let sDay = this.startDate.split("/")[2];
      let eDay = n.split("/")[2];
      if (parseInt(sDay) < parseInt(eDay)) {
        this.isBigger = true;
      } else {
        this.isBigger = false;
      }
    },
    setSessionGroupStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getAllSessionGroupsFunction({
            user_id: this.user.user_id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    this.users = this.allUsers;
    if (Object.keys(this.allUserOrg).length && this.allUserOrg.organ_list.length) {
      this.allUserOrgList = this.allUserOrg.organ_list;
    }
    if (Object.keys(this.allSessionGroups).length && this.allSessionGroups.session_groups.length) {
      this.allSessionGroupsList = this.allSessionGroups.session_groups;
    }
    if (Object.keys(this.sessionStep1Data).length) {
      this.title = this.sessionStep1Data.title;
      this.capacity = this.sessionStep1Data.capacity;
      this.userOrg = this.sessionStep1Data.userOrg;
      this.sessionGroup = this.sessionStep1Data.sessionGroup;
      this.startDate = this.sessionStep1Data.startDate;
      this.startTime = this.sessionStep1Data.startTime;
      this.isactive = this.sessionStep1Data.days;
      this.repeatPeriod = this.sessionStep1Data.isRepeat;
      this.isTabAvtive = this.sessionStep1Data.isTabAvtive;
      this.selectDaysList = this.sessionStep1Data.daysList;
      setTimeout(() => {
        this.endDate = this.sessionStep1Data.endDate;
        this.endTime = this.sessionStep1Data.endTime;
      }, 500);
    }
  },
};
</script>
